import { render } from "./ProjectLanguagePage.vue?vue&type=template&id=5edf8e83&scoped=true"
import script from "./ProjectLanguagePage.vue?vue&type=script&lang=js"
export * from "./ProjectLanguagePage.vue?vue&type=script&lang=js"

import "./ProjectLanguagePage.vue?vue&type=style&index=0&id=5edf8e83&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-5edf8e83"

export default script